import { render, staticRenderFns } from "./printTransferMajor.vue?vue&type=template&id=941abeba&scoped=true&"
import script from "./printTransferMajor.vue?vue&type=script&lang=js&"
export * from "./printTransferMajor.vue?vue&type=script&lang=js&"
import style0 from "./printTransferMajor.vue?vue&type=style&index=0&id=941abeba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941abeba",
  null
  
)

export default component.exports